export const APPLICATION_TYPE_Z_BUSINESS = 'ZBusiness';
export const APPLICATION_TYPE_AVIATION = 'Aviation';

export const APPLICATION_TYPE = {
  [APPLICATION_TYPE_Z_BUSINESS]: 1,
  [APPLICATION_TYPE_AVIATION]: 2
};
